/*
 * Module module for the Employer Association's Plan View
*/

rs.module("content/employer/account/associations/plan",

    ["common/select-helper"],

    function (selectHelper) {

        //
        // Initialize
        //
        function initialize(jsSelectors, backendUrl) {

            var form = $.js(jsSelectors.form);

            // 
            form.js(jsSelectors.fundSelect).change(function () {

                selectHelper.getHelper(form.js(jsSelectors.planSelect)).loadOptionsFrom(
                    backendUrl,
                    {
                        fundKey: $(this).val()
                    },
                    {
                        withBlank: true
                    });
            });

        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);